import Colors from 'constants/Colors';

export default {
  title: {
    color: Colors.blueStrongColor,
    fontSize: 16,
    fontWeight: 'bold',
  },
  text: {
    color: Colors.darkText,
    fontSize: 14,
  },
};
